import { createSlice } from "@reduxjs/toolkit";

interface UserState {
  user: any | null;
  isAuthenticated: boolean;
}

const initialState: UserState = {
  user: null,
  isAuthenticated: false,
};

const AuthSlice = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    login: (state: any, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem('_session', '1');
    },
    logout: (state: any, action) => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem('_session');
    },
    update: (state: any, action) => {
      state.user = action.payload;
    },
    setUser: (state: any, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem('_session', '1');
    },
  },
});

export const { login, logout, update, setUser } = AuthSlice.actions;
export default AuthSlice.reducer;
